export const MIXPANEL_EVENTS_PERMISSIONS_DENIED = {
  PERMISSIONS_DENIED_VIEW_OPEN: 'permissions_denied_view_open',
  PERMISSIONS_DENIED_RETRY_REQUEST: 'permissions_denied_retry_request'
}
